import {connect} from "react-redux";
import {ReactSortable} from 'react-sortablejs';
import React, {useEffect, useState} from 'react';
import uniqueId from 'lodash/uniqueId';
import {addPort as utilsAddPort, editButton, removePort as utilsRemovePort} from "../InputPortListUtils/InputPortUtils";
import logicGraphDataActions from "../../../../actions/logicGraphDataActions";
import {SegmentSelect} from "./SegmentSelect";
import {InputEntry} from "../InputPortListUtils/InputEntry";
import {AddInputButton} from "../InputPortListUtils/components/AddInputButton";
import {clickedNodeAction} from "../../../../actions/clickedNodeActions";
import ContentWithTopLabel from "../ContentWithTopLabel";
import SelectBox from "../SelectBox";
import {StaticTextLabel} from "./components/StaticTextLabel";
import axios from "axios";
import axiosConfig from "../../../../utils/axiosConfig";
import messageCodes from "../../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../../actions/toastActions";
import {RadioLabel} from "./components/RadioLabel";
import InputWithLabel from "../InputWithLabel";

const ABTestInputPortList = (props) => {
    const {clickedNodeInfo, properties} = props;
    const nodeOptions = clickedNodeInfo.extras.options;
    const segmentationMap = props.segmentationMap;

    const [portList, setPortList] = useState([])
    const [options, setOptions] = useState({
        inputPortData: nodeOptions?.inputPortData ? nodeOptions.inputPortData : [],
        logDecisionName: nodeOptions?.logDecisionName ? nodeOptions.logDecisionName : '',
        userPropertyName: nodeOptions?.userPropertyName ? nodeOptions.userPropertyName : null,
        segmentation: nodeOptions?.segmentation ? nodeOptions.segmentation : null,
        contextUserId: nodeOptions?.contextUserId ? nodeOptions.contextUserId : ''
    })

    const [userProperties, setUserProperties] = useState([])
    const [radioButtonValue, setRadioButtonValue] = useState(nodeOptions.userPropertyName !== null ? 'userPropertyName' : 'segment');
    const [selectedSegmentation, setSelectedSegmentation] = useState('')

    useEffect(() => {
        createList();
        setSelectedSegmentation(props.clickedNodeInfo.extras.options.segmentation);
    }, []);

    useEffect(() => {
        if (properties) {
            getUserProperties();
        }
    }, [properties]);

    useEffect(() => {
        if (portList.length > 0) {
            createOption();
        }
    }, [portList, radioButtonValue])

    const updateProperty = (property, value) => {
        let clickedNodeInfo = {...props.clickedNodeInfo}
        if (!Object.prototype.hasOwnProperty.call(clickedNodeInfo.extras, "options")) {
            clickedNodeInfo.extras.options = {};
        }
        clickedNodeInfo.extras.options = {
            ...options,
            [property]: value
        };

        setOptions({
            ...options,
            [property]: value
        })

        if (radioButtonValue === 'userPropertyName') {
            clickedNodeInfo.extras.options.userPropertyName = value;
        }
        props.clickedNodeAction(clickedNodeInfo);
    }

    const onOptionsUpdate = (type, value, portID) => {
        const newPortList = [...portList]
        const portIndex = newPortList.map(port => {
            return port.id;
        }).indexOf(portID);

        if (type === 'segmentationGroup') {
            newPortList[portIndex].segmentationGroup = value;
        }
        if (type === 'resetSegment') {
            newPortList[portIndex].segment = null;
            newPortList[portIndex].segmentId = null;
            newPortList[portIndex].segmentType = null;
        }
        if (type === 'external') {
            newPortList[portIndex].segment = value
            newPortList[portIndex].segmentId = value;
            newPortList[portIndex].segmentType = "external";
        }
        if (type === 'segment') {
            newPortList[portIndex].segment = value;
            const segment = segmentationMap?.get(selectedSegmentation).filter((segment) => segment.segmentName === value)[0];
            newPortList[portIndex].segmentId = segment.segmentId;
            newPortList[portIndex].segmentType = segment.type;
        }

        setPortList(newPortList);
    }

    const createList = async () => {
        const engine = props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();

        const clickedNodeInfo = Object.assign({}, props.clickedNodeInfo);
        const portList = [];
        const inputPortData = clickedNodeInfo.extras.options.inputPortData;

        Object.values(clickedNodeInfo.ports).forEach((v, i) => {
            const nodeOptions = JSON.parse(JSON.stringify(options));
            const values = {
                logDecisionValue: '',
                segment: nodeOptions.segment,
                segmentation: nodeOptions.segmentation,
                segmentId: nodeOptions.segmentId,
                segmentType: nodeOptions.segmentType,
            };

            if (typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in) {
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.segment = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].segment : true;
                values.segmentation = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].segmentation : true;
                values.segmentId = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].segmentId : true;
                values.segmentType = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].segmentType : true;
            }

            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                branchName: '',
                index: 0,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: values.logDecisionValue,
                segment: values.segment,
                segmentation: values.segmentation,
                segmentId: values.segmentId,
                segmentType: values.segmentType,
                in: v.options.in
            }

            if (v.connection) {
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if (link.sourcePort === v.options.id) {
                        nodeID = link.target;
                    }
                    if (link.targetPort === v.options.id) {
                        nodeID = link.source;
                    }
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0]
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            } else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v, i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });
        setPortList(newPortList);
    }

    const createOption = () => {
        const inputPortData = [];
        const newPortList = [...portList];

        const inputPortList = newPortList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                logDecisionValue: v.nodeName,
                userPropertyName: v.userPropertyName,
                segmentation: v.segmentation,
                segment: v.segment,
                segmentId: v.segmentId,
                segmentType: v.segmentType,
                contextUserId: v.contextUserId
            });
        });

        const newOptions = Object.assign({}, options);
        newOptions.inputPortData = inputPortData;
        newOptions.logDecisionName = props.clickedNodeInfo.extras.options.logDecisionName;
        newOptions.userPropertyName = props.clickedNodeInfo.extras.options.userPropertyName;
        newOptions.contextUserId = props.clickedNodeInfo.extras.options.contextUserId;
        newOptions.segmentation = props.clickedNodeInfo.extras.options.segmentation;
        newOptions.segment = props.clickedNodeInfo.extras.options.segment;
        newOptions.segmentId = props.clickedNodeInfo.extras.options.segmentId;
        newOptions.segmentType = props.clickedNodeInfo.extras.options.segmentType;

        const logicGraphData = {
            options: newOptions,
            portList: newPortList,
            id: clickedNodeInfo.options.id
        }
        props.logicGraphDataActions(logicGraphData);
    }

    const removePort = (item) => {
        const newPortList = utilsRemovePort(portList, item);
        setPortList(newPortList)
    }

    const addPort = () => {
        const newPortList = utilsAddPort({portList, options}, props.clickedNodeInfo.options.id, 'a_b_test');
        setPortList(newPortList)
    }

    const editInputButton = (item) => {
        const setEditValue = editButton(portList, item);
        setPortList(setEditValue)
    }

    const updateUserPropertyName = (event) => {
        options.userPropertyName = event.target.value;
        updateProperty("userPropertyName", event.target.value)
    }

    const updateContextUserId = (event) => {
        options.contextUserId = event.target.value;
        updateProperty("contextUserId", event.target.value)
    }

    const inputHandle = (event, item, name) => {
        let process = false;
        const portList = {...options.inputPortData};
        const setInputData = Object.values(portList).map((v) => {
            if (v.id === item.id) {
                if (name === 'logDecisionValue' && v.logDecisionValue !== event.target.value) {
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if (process) {
            setOptions({
                ...options,
                inputPortData: setInputData
            });
        }
    }

    const defaultPort = (data) => {
        if (data.length === 0) return [];
        const newPortList = portList;
        const outputCount = newPortList.filter(port => !port.in).length;
        const inputPortListCount = newPortList.length - outputCount;

        return data.map((val) => {
            return (
                <InputEntry value={val} key={val.id}
                            removePort={removePort}
                            inputHandle={inputHandle}
                            editButton={editInputButton}
                            inputListCount={inputPortListCount > 3}
                            hideEditor
                >
                    {radioButtonValue === 'segment' ? (
                        <SegmentSelect disabled={radioButtonValue !== 'segment'}
                                       segmentOptions={segmentationMap.get(selectedSegmentation)}
                                       selectedSegment={val.segment}
                                       onSelectSegment={(segment) => onOptionsUpdate("segment", segment, val.id)}/>
                    ) : (
                        <div className="filter-group">
                            <div className="filter-group-content">
                                <InputWithLabel
                                    label="Segment:"
                                    handleChange={(event) => onOptionsUpdate("external", event.target.value, val.id)}
                                    value={val.segment}
                                />
                            </div>
                        </div>
                    )}
                </InputEntry>
            )
        })
    }

    const groupCreate = () => {
        const portListData = portList.filter(port => port.in);

        const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
        return (
            <ReactSortable key="static"
                           animation={150}
                           handle='.drag-handle'
                           group={'default_group' + uniqueId()}
                           pull={true}
                           put={true}

                           list={portListData}
                           setList={(newState) => {
                               if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                                   const newPortList = [...newState];
                                   newPortList.forEach((val, key) => {
                                       val.index = key;
                                       return val;
                                   });
                                   const outputPortList = portList.filter(port => port.in === false);
                                   outputPortList.forEach((v) => {
                                       newPortList.push(v);
                                   });

                                   setOptions({
                                       ...options,
                                       inputPortData: newPortList
                                   });
                                   setPortList(newPortList)
                               }
                           }}
                           className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
            >
                {defaultPort(portListData)}
            </ReactSortable>
        )
    }

    const getUserProperties = async () => {
        if (userProperties.length === 0) {
            await axios.get(props.properties.databaseUrl + "/properties/users", axiosConfig())
                .then(response => {
                    setUserProperties(response.data)
                })
                .catch(err => {
                    if (err.response) {
                        props.showToastForBackend(err.response.data);
                    } else {
                        props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                    }
                });
        }
    }

    const handleRadioButtonChange = (event) => {
        const value = event.target.value
        setRadioButtonValue(value);

        let userPropertyNameValue;
        if (value === 'userPropertyName') {
            userPropertyNameValue = options.userPropertyName === null && userProperties.length > 0 ? userProperties[0] : options.userPropertyName;
            setSelectedSegmentation(null);
            updateSegmentation(null);
        } else {
            userPropertyNameValue = null;
        }
        resetInputSegments();

        options.userPropertyName = userPropertyNameValue;
        clickedNodeInfo.extras.options.userPropertyName = userPropertyNameValue;
        props.clickedNodeAction(clickedNodeInfo);

        const newOptions = {
            ...options,
            userPropertyName: userPropertyNameValue
        }

        props.logicGraphDataActions({...props.logicGraphData, options: newOptions});
    };

    const handleSegmentationChange = (event) => {
        const segmentation = event.target.value;
        setSelectedSegmentation(segmentation);

        updateSegmentation(segmentation);
    };

    const updateSegmentation = (segmentation) => {
        updateProperty("segmentation", segmentation)

        const clickedNodeInfo = props.clickedNodeInfo;
        const selectGroupInfo = {
            ...clickedNodeInfo,
            extras: {options: {...clickedNodeInfo.extras.options, segmentation: segmentation}}
        };
        props.clickedNodeAction(selectGroupInfo);

        portList.filter(port => port.in).forEach((val) => {
            onOptionsUpdate("segmentation", segmentation, val.id)
        })
    }

    const resetInputSegments = () => {
        portList.filter(port => port.in).forEach((val) => {
            onOptionsUpdate("resetSegment", null, val.id)
        })
    }

    return (
        <div>
            <ContentWithTopLabel label="Mode">
                <div className="mode-radio-button">
                    <RadioLabel
                        label="User Property"
                        value="userPropertyName"
                        checkedValue={radioButtonValue}
                        onChange={handleRadioButtonChange}
                    />
                    <RadioLabel
                        label="Segmentation"
                        value="segment"
                        checkedValue={radioButtonValue}
                        onChange={handleRadioButtonChange}
                    />
                </div>
            </ContentWithTopLabel>
            <ContentWithTopLabel label="User id">
                <div className="input-container">
                    <span className="static-text" style={{margin: '10px'}}>User id from context property:</span>
                    <div>
                        <SelectBox handleChangeSelect={updateContextUserId}
                                   selectValue={options.contextUserId}
                                   selectArray={props.contextProperties.map(property => ({
                                       label: property.name,
                                       value: property.name
                                   }))}
                                   showDefault
                        />
                    </div>
                </div>
            </ContentWithTopLabel>
            {radioButtonValue === 'userPropertyName' && (
                <ContentWithTopLabel label="User Property">
                    <div className="input-container">
                        <StaticTextLabel>User property with segment: </StaticTextLabel>
                        <SelectBox handleChangeSelect={updateUserPropertyName}
                                   selectValue={options.userPropertyName}
                                   selectArray={userProperties.map(property => ({
                                       label: property,
                                       value: property
                                   }))}
                                   showDefault
                        />
                    </div>
                </ContentWithTopLabel>
            )}

            {radioButtonValue !== 'userPropertyName' && (
                <ContentWithTopLabel label="Segmentation">
                    <div className="input-container">
                        <StaticTextLabel>Segmentation name: </StaticTextLabel>
                        <SelectBox handleChangeSelect={handleSegmentationChange}
                                   selectValue={selectedSegmentation}
                                   selectArray={Array.from(segmentationMap.keys()).map(group => ({
                                       label: group,
                                       value: group
                                   }))}
                                   showDefault
                        />
                    </div>
                </ContentWithTopLabel>
            )}
            <ContentWithTopLabel label="Inputs"/>
            <div className="node-input-list">
                {
                    portList && groupCreate()
                }
                <AddInputButton onClick={addPort} label="Add Input"/>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties,
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData,
        properties: state.properties
    }
}

export default connect(mapStateToProps, {
    logicGraphDataActions,
    clickedNodeAction,
    showToastForFrontend,
    showToastForBackend
})(ABTestInputPortList);
